export default "__VITE_ASSET__DY4mQ2MH__"